import {
  GRAVITY,
  HOP_HOLD_BOOST,
  HOP_HOLD_MAX_S,
  HOP_VELOCITY,
  RAMP_VELOCITY,
  SEND_SPEED_MUL,
  TICK_S,
  TUCK_SPEED_BONUS,
} from './constants';

/**
 * Ballistics shared by the level generator, the simulation and the test bot.
 *
 * The generator has to reserve clear track for as long as a rider can possibly
 * be airborne. Getting that from *nominal* speed is wrong: a tucked rider on a
 * send is well over a third faster than nominal, and both the flight time and
 * the ground covered scale with it. Computing the worst case here, once, is
 * what stops a gap being placed exactly where a ramp drops you.
 */

const hopCache = new Map<number, number>();

/** Seconds a fully-held bunny hop keeps you off the ground. */
export function hopAirSeconds(gravity: number): number {
  const key = Math.round(gravity * 100);
  const hit = hopCache.get(key);
  if (hit !== undefined) return hit;

  const maxHold = Math.floor(HOP_HOLD_MAX_S / TICK_S);
  let v = HOP_VELOCITY;
  let y = 0;
  let t = 0;
  for (let i = 0; i < 4000; i++) {
    if (i < maxHold && v > 0) v += HOP_HOLD_BOOST * TICK_S;
    v -= gravity * TICK_S;
    y += v * TICK_S;
    t += TICK_S;
    if (y <= 0) break;
  }
  hopCache.set(key, t);
  return t;
}

/** Seconds of hang time from a ramp, at `speedRatio` of the world's base ceiling. */
export function rampAirSeconds(gravity: number, speedRatio: number): number {
  const ratio = Math.min(1, speedRatio);
  const vy = RAMP_VELOCITY * ratio * 0.55 + RAMP_VELOCITY * 0.5;
  return (2 * vy) / gravity;
}

/**
 * Fastest a rider can realistically be travelling, as a multiple of the world's
 * base ceiling: tucked, mid-send, sitting on the clamp.
 */
export const TOP_SPEED_RATIO = TUCK_SPEED_BONUS * SEND_SPEED_MUL * 1.02;

export function worldGravity(themeGravity: number): number {
  return GRAVITY * themeGravity;
}
